import React, { forwardRef } from 'react';
import { Icon } from '../../design/Icon';
import { useTheme } from '../../design/ThemeProvider';

const VARIANT_CLASS = { default: '', primary: 'btn-primary', ghost: 'btn-ghost', danger: 'btn-danger' };
const SIZE_CLASS = { md: '', sm: 'btn-sm', lg: 'btn-lg' };

export const Button = forwardRef(function Button(
  { variant = 'default', size = 'md', icon, iconAfter, iconOnly = false, className = '', type = 'button', children, ...rest },
  ref
) {
  const classes = ['btn', VARIANT_CLASS[variant], SIZE_CLASS[size], iconOnly ? 'icon-btn' : '', className]
    .filter(Boolean)
    .join(' ');
  return (
    <button ref={ref} type={type} className={classes} {...rest}>
      {icon && <Icon name={icon} className={size === 'sm' ? 'ico-sm' : ''} />}
      {children}
      {iconAfter && <Icon name={iconAfter} className="ico-sm" />}
    </button>
  );
});

export const IconButton = forwardRef(function IconButton({ icon, label, variant = 'ghost', size = 'md', ...rest }, ref) {
  return (
    <Button ref={ref} variant={variant} size={size} iconOnly aria-label={label} title={label} icon={icon} {...rest} />
  );
});

export function ThemeToggle({ withLabel = false, className = '' }) {
  const { isDark, toggleTheme } = useTheme();
  const label = isDark ? 'Switch to light theme' : 'Switch to dark theme';
  return (
    <button
      type="button"
      className={['btn', 'btn-ghost', withLabel ? '' : 'icon-btn', className].filter(Boolean).join(' ')}
      aria-label={label}
      title={label}
      onClick={toggleTheme}
    >
      <Icon name={isDark ? 'sun' : 'moon'} />
      {withLabel && <span>{isDark ? 'Light theme' : 'Dark theme'}</span>}
    </button>
  );
}

export function Segmented({ options, value, onChange, label, className = '' }) {
  return (
    <div className={`seg ${className}`.trim()} role="group" aria-label={label}>
      {options.map((option) => {
        const optionValue = typeof option === 'string' ? option : option.value;
        const optionLabel = typeof option === 'string' ? option : option.label;
        return (
          <button
            key={optionValue}
            type="button"
            aria-pressed={optionValue === value ? 'true' : 'false'}
            onClick={() => onChange && onChange(optionValue)}
          >
            {optionLabel}
          </button>
        );
      })}
    </div>
  );
}
